import api from '@api/index'
import { addToast } from '@components/atoms/Toast'
import { Certification } from '@hooks/profile/interfaces'
import { useUserContext } from '@hooks/user/UserContextProvider'
import { useState } from 'react'

export const useCertification = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [response, setResponse] = useState<any>(null)

  const { logOut } = useUserContext()

  const update = async (data: Certification) => {
    setLoading(true)
    try {
      const res = await api.put(`/users/profile`, {
        profile: {
          certifications_attributes: data.id
            ? {
                ...data
              }
            : [{ ...data }]
        }
      })
      setResponse(res)
      addToast({ title: 'Successfully updated' }, 'success', {})
    } catch (error: any) {
      if (error?.response?.status === 401) logOut()
    } finally {
      setLoading(false)
    }
  }

  return { loading, response, update }
}
